export default __webpack_public_path__ + "static/ai-c8a33d1da2cd795bf3fb73e1b912b090.png";